import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MiscService } from '../../_service/misc.service';
import { DentalService } from '../../_service/dental.service';
import { SharedService } from '../../_service/shared.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-bucket-wise-pending-payment',
  templateUrl: './bucket-wise-pending-payment.component.html',
  styleUrls: ['./bucket-wise-pending-payment.component.css']
})
export class BucketWisePendingPaymentComponent implements OnInit {
  treatList=[]; start_date:string='';end_date:string='';

  /***********Clinic Wise*********** */
  bucket_wise_pending_payment_loading:boolean=false;bucket_treatment='';bucketWisePendingPayment = [];total_above_45 = 0;total_above_30=0;total_above_15=0;total_below_15=0;total_overall_pending=0;total_converted=0;total_sd=0;total_lead_count=0;
  constructor(private dentalapi:DentalService,private sharedapi:SharedService,public miscapi:MiscService) { }
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  ngOnInit(): void {
    this.getTreatmentCategory();
    this.getBucketWisePendingPayment();
  }

  async getTreatmentCategory()
  {
      await this.miscapi.getDentalTraetment().subscribe((data:any) => {
          if(data.status)
          {
              this.treatList = data.data;
          }else{
              this.treatList = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getBucketWisePendingPayment()
  {
    this.bucket_wise_pending_payment_loading=true;
    this.bucketWisePendingPayment = [];
    this.total_above_45 = 0;this.total_above_30=0;this.total_above_15=0;this.total_below_15=0;this.total_overall_pending=0;this.total_converted=0;this.total_sd=0;this.total_lead_count = 0;

    let qString = 'date_range='+this.start_date+'-'+this.end_date+'&treatment='+this.bucket_treatment;
    await this.dentalapi.getBucketWisePendingPayment(qString).subscribe((data:any) => {
        this.bucket_wise_pending_payment_loading=false;
        if(data.status)
        {
          this.bucketWisePendingPayment = data.data;
          this.total_lead_count = this.bucketWisePendingPayment.map(item => item.lead_count).reduce((prev, curr) => prev + curr, 0);
          this.total_sd = this.bucketWisePendingPayment.map(item => item.sd).reduce((prev, curr) => prev + curr, 0);
          this.total_converted = this.bucketWisePendingPayment.map(item => item.converted).reduce((prev, curr) => prev + curr, 0);
          this.total_below_15 = this.bucketWisePendingPayment.map(item => Number(item.below_15)).reduce((prev, curr) => prev + curr, 0);
          this.total_above_15 = this.bucketWisePendingPayment.map(item => Number(item.above_15)).reduce((prev, curr) => prev + curr, 0);
          this.total_above_30 = this.bucketWisePendingPayment.map(item => Number(item.above_30)).reduce((prev, curr) => prev + curr, 0);
          this.total_above_45 = this.bucketWisePendingPayment.map(item => Number(item.above_45)).reduce((prev, curr) => prev + curr, 0);
          this.total_overall_pending = this.total_below_15 + this.total_above_15 + this.total_above_30 + this.total_above_45;
        }else{
          this.bucketWisePendingPayment = [];
          this.total_above_45 = 0;this.total_above_30=0;this.total_above_15=0;this.total_below_15=0;this.total_overall_pending=0;this.total_converted=0;this.total_sd=0;this.total_lead_count = 0;
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  exportBucketWisePendingPayment()
  {
    if(this.bucketWisePendingPayment.length>0)
    {
      let data = [];
      let titles = [
        'Circle',
        'Total Leads',
        'SD',
        'Converted',
        'Overall Pending',
        'Below 15',
        'Above 15',
        'Above 30',
        'Above 45'
      ];
      data.push(titles);
      for(let bucketWisePayment in this.bucketWisePendingPayment)
      {
        let exdata = [
          this.bucketWisePendingPayment[bucketWisePayment].name,
          this.bucketWisePendingPayment[bucketWisePayment].lead_count,
          this.bucketWisePendingPayment[bucketWisePayment].sd,
          this.bucketWisePendingPayment[bucketWisePayment].converted,
          this.bucketWisePendingPayment[bucketWisePayment].below_15 + this.bucketWisePendingPayment[bucketWisePayment].above_15 + this.bucketWisePendingPayment[bucketWisePayment].above_30 + this.bucketWisePendingPayment[bucketWisePayment].above_45,
          this.bucketWisePendingPayment[bucketWisePayment].below_15,
          this.bucketWisePendingPayment[bucketWisePayment].above_15,
          this.bucketWisePendingPayment[bucketWisePayment].above_30,
          this.bucketWisePendingPayment[bucketWisePayment].above_45,
        ];
        data.push(exdata);
      }
      
      data.push(
        [
          'Overall',
          this.total_lead_count,
          this.total_sd,
          this.total_converted,
          this.total_overall_pending,
          this.total_below_15,
          this.total_above_15,
          this.total_above_30,
          this.total_above_45,
        ]
      );
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'bucket_wise_pending_payment_'+utc+'.xlsx');
    }
    else
    {
      this.sharedapi.presentToast('No Data Found');
    }
  }

  dateRangeChangeBucketWise(date1,date2)
  {
    if(date2.value)
    {
      this.start_date = date1.value;
      this.end_date = date2.value;
      this.getBucketWisePendingPayment();
    }
  }

  clearDate(type)
  {
    if(type==1){
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.getBucketWisePendingPayment();
    }
  }

}
